module.exports = __webpack_public_path__ + "img/right_tip.0ef68739.png";